import React, { useState } from 'react';
import styled from 'styled-components';
import colors from '../../../styles/colors';
import NoContent from '../../../shared/NoContent';
import BaseModal, { ModalList } from '../../modals/BaseModal';

const ListContainer = styled.ul`
    padding: 15px;
    display: grid;
    margin:0;
    grid-template-columns: repeat(auto-fill,minmax(250px,1fr));

    @media screen and (max-width:300px){
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
  
`;

const ListItem = styled.li`
  cursor: pointer;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.25);
  font-size: 1.3rem !important;
  padding: 7px 35px;
  color: #333333;
  list-style-type: none;
  border-radius: 7px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: auto;
  margin: 10px 10px;
  min-height: 50px;
  font-size: 17px;
  position: relative;
  text-align: start;
  @media screen and (max-width:300px){
    margin: 10px 0;
  }
`;

const Wrapper = styled.div`
  background: ${colors.white};
  width: 100%;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  box-sizing: border-box;
  border-radius: 10px;
  border: 1px solid ${colors.grey6};
  min-height:400px;
  margin-bottom:50px;
`;

function ClientsList({
  clients, setClientData, clientData,
  setOrgName, sendMmsEnabled, refetch,
  isStagingEnv,
}) {
  const [detailsModalVisible, setDetailsModalVisible] = useState(false);
  const [mmsActivatedIds, setMmsActivatedIds] = useState([]);

  const listItemClick = (item) => {
    setClientData(item);
    setDetailsModalVisible(true);
  };

  return (
    <>
      <BaseModal
        open={detailsModalVisible}
        modalType={ModalList.ClientDetailsModal}
        onClose={setDetailsModalVisible}
        clientData={clientData}
        sendMmsEnabled={sendMmsEnabled}
        setOrgName={setOrgName}
        refetch={refetch}
        setDetailsModalVisible={setDetailsModalVisible}
        setMmsActivatedIds={setMmsActivatedIds}
        mmsActivatedIds={mmsActivatedIds}
        isStagingEnv={isStagingEnv}
      />
      <Wrapper>
        {clients && clients.length > 0 ? (
          <ListContainer>
            { clients.map((item) => (
              <ListItem key={item._id} onClick={() => listItemClick(item)}>
                {item.name}
              </ListItem>
            ))}
          </ListContainer>
        )
          : <NoContent header="No Clients" description="No Clients Available" />}
      </Wrapper>
    </>
  );
}

export default ClientsList;
